import { styled } from "@mui/material";
import React from "react";
import ReactMarkdown, { Options as ReactMarkdownOptions } from "react-markdown";

/** Component extension for providing MUI typography styling to the types of HTML that are created from the markdown plugin.
 *  Note that scale for header markdown has been adjusted to only provide feasible font sizes.
 */
const Wrapper = styled("div")(({ theme }) => ({
  "& h1": { ...theme.typography.h3 },
  "& h2": { ...theme.typography.h4 },
  "& h3": { ...theme.typography.h5 },
  "& h4": { ...theme.typography.h6 },
  "& h5": { ...theme.typography.h6 },
  "& h6": { ...theme.typography.h6 },
  "& p": { ...theme.typography.body1 },
  "& li": { ...theme.typography.body1 }
}));

/** The {@link ReactMarkdown} component with desired MUI styling applied. */
const StyledReactMarkdown: React.FC<ReactMarkdownOptions> = props => (
  <Wrapper>
    <ReactMarkdown {...props} />
  </Wrapper>
);

export default StyledReactMarkdown;
